<template>
  <div></div>
</template>

<script>

import { mapState } from 'vuex';
import Intercom from '@/Intercom';
import DDLogs from '@/DDLogs';
import consts from '../../../../constants/onboarding-state';

export default {
  name: 'StateRouter',
  async created() {
    const redirectPath = this.getRedirectPath();
    DDLogs.log('Redirecting path', { customerId: this.customerId, redirectedFrom: this.$route.redirectedFrom, redirectPath });
    if (this.$route.query.showIntercom) {
      Intercom.show();
    }
    // eslint-disable-next-line no-unused-vars
    const { showIntercom, ...query } = this.$route.query;
    this.$router.replace({ path: redirectPath, query });
  },
  computed: {
    ...mapState('customerState', ['onboardingStatus']),
    ...mapState('session', ['customerId']),
    ...mapState('onboardingState', ['pageName']),
    ...mapState('tour', ['hasTourPending']),
  },
  methods: {
    getRedirectPath() {
      if (this.$route.query.error_description === 'Access expired.') {
        return '2fa-Link-Expired';
      }
      if (this.pageName && this.pageName !== consts.ONBOARDING_PAGE.CASHFLOW) {
        return 'ob';
      }
      if (this.hasTourPending) {
        return 'tour';
      }
      return 'home';
    },
  },
};
</script>
